(function() {
  "use strict";

  function globalCommentsMenu() {
    return {
      restrict: "E",
      templateUrl: "dashboards/directives/templates/globalCommentsMenu.html",
      scope: {
        comments: "="
      },
      link: function(scope, element, attrs) {
      }
    };
  }

  globalCommentsMenu.$inject = [];

  angular
    .module("ecap.dashboards")
    .directive("globalCommentsMenu", globalCommentsMenu);
})();
